import { OrderedMap } from 'immutable';
import * as ActionTypes from '../../actions/ActionTypes';
import CategoryOrganizationRecord from '../../records/edit/CategoryOrganizationRecord';
import CategoryRecord from '../../records/edit/CategoryRecord';
export function getCategories({
  categories = []
}) {
  // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
  return new OrderedMap(categories.map(category => [category.id, CategoryRecord.from(category)]));
}
const INITIAL_STATE = new CategoryOrganizationRecord();
export default function categoryOrganizationBuffer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.CLEAR_ORGANIZE_STATE:
      return INITIAL_STATE;
    case ActionTypes.FETCH_CATEGORY_ORGANIZATION_BUFFER_PENDING:
      return state.set('isRequesting', true);
    case ActionTypes.FETCH_TRANSLATED_CATEGORY_ORGANIZATION_BUFFER_SUCCESS:
      return state.merge({
        categories: getCategories(action.payload),
        isRequesting: false,
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'null | un... Remove this comment to see the full error message
        lastLoaded: new Date().valueOf(),
        requestedLanguage: action.payload.requestedLanguage,
        primaryLanguage: action.payload.primaryLanguage
      });
    case ActionTypes.FETCH_CATEGORY_ORGANIZATION_BUFFER_SUCCESS:
      return state.merge({
        categories: getCategories(action.payload),
        isRequesting: false,
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'null | un... Remove this comment to see the full error message
        lastLoaded: new Date().valueOf()
      });
    case ActionTypes.FETCH_CATEGORY_ORGANIZATION_BUFFER_ERROR:
      return state.merge({
        error: action.error,
        isRequesting: false
      });
    case ActionTypes.CREATE_CATEGORY_PENDING:
      return state.merge({
        error: undefined,
        isCreating: true
      });
    case ActionTypes.CREATE_CATEGORY_SUCCESS:
      return state.merge({
        error: undefined,
        isCreating: false,
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'null | un... Remove this comment to see the full error message
        lastCreated: new Date().valueOf()
      });
    case ActionTypes.CREATE_CATEGORY_ERROR:
      return state.merge({
        error: action.error,
        isCreating: false
      });
    case ActionTypes.UPDATE_CATEGORY_PENDING:
      return state.merge({
        isUpdating: true,
        error: undefined
      });
    case ActionTypes.UPDATE_CATEGORY_SUCCESS:
      return state.merge({
        error: undefined,
        isUpdating: false,
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'null | un... Remove this comment to see the full error message
        lastUpdated: new Date().valueOf()
      });
    case ActionTypes.UPDATE_CATEGORY_ERROR:
      return state.merge({
        isUpdating: false,
        error: action.error
      });
    case ActionTypes.UPDATE_CATEGORY_ORDERING_PENDING:
    case ActionTypes.UPDATE_SUBCATEGORY_ORDERING_PENDING:
    case ActionTypes.UPDATE_ARTICLE_ORDERING_PENDING:
      return state.merge({
        isOrdering: true
      });
    case ActionTypes.UPDATE_CATEGORY_ORDERING_SUCCESS:
    case ActionTypes.UPDATE_SUBCATEGORY_ORDERING_SUCCESS:
    case ActionTypes.UPDATE_ARTICLE_ORDERING_SUCCESS:
      return state.merge({
        isOrdering: false,
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'null | un... Remove this comment to see the full error message
        lastLoaded: new Date().valueOf(),
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'true' is not assignable to type 'undefined'.
        orderingSuccess: true
      });
    case ActionTypes.UPDATE_CATEGORY_ORDERING_ERROR:
    case ActionTypes.UPDATE_SUBCATEGORY_ORDERING_ERROR:
    case ActionTypes.UPDATE_ARTICLE_ORDERING_ERROR:
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'false' is not assignable to type 'undefined'... Remove this comment to see the full error message
      return state.merge({
        isOrdering: false,
        orderingSuccess: false
      });
    default:
      return state;
  }
}